<template lang="html">
  <div class="exchange">
    <common-header></common-header>
    <div class="imgContainer">
    	<div><img src="../../../assets/img/aboutUsKv.png" /></div>
    </div>
    <div class="exchangeContainer">
    	<div class="usTab">兑换积分
    		<img src="../../../assets/img/aboutUsTag.png" />
    	</div>
    	<div class="contentBox">
    		<div class="title">如何兑换君弘积分</div>
    		<div class="eng-title">一、兑换渠道</div>
    		<div class="abstract">
				目前会员可通过登录君弘网站：www.junhongclub.com 进入“积分商城”进行积分兑换，未来我们将开通营业部现场兑换渠道以及95521客服热线兑换渠道。</div>
			<div class="eng-title">二、兑换流程</div>
    		<div class="abstract">
				进入积分商城（查看商城中的服务或产品）→积分兑换（选择兑换礼品）→填写兑换信息（兑换服务或产品的期限、数量，若为实物产品需填写发货信息）→兑换成功，扣减积分→回到积分商城，继续浏览。</div>
    	</div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../../components/common/commonHeader'
	import commonFooter from '../../../components/common/commonFooter'
	import listKv from '../../../components/common/listKv'
	//接口
	import Server from '../../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	  	created(){
	  		//
	  	},
	}
</script>

<style lang="less" scoped>
	.exchange{
		.imgContainer{
			padding:0px 40px;
			width:100%;
			margin-top:150px;
			div{
				width:100%;
				border-radius:10px;
				overflow:hidden;
				img{
					width:100%;	
					height:340px;
				}
			}
		}
		.exchangeContainer{
			width:100%;
			margin-top:30px;
			padding:0 40px;
			.usTab{
				width:100%;
				height:80px;
				padding:0 30px;
				line-height:80px;
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				border-radius:10px;
				text-align:left;
				color:#ad8f5a;
				font-size:28px;
				img{
					width:32px;
					float:right;
					margin-top:24px;
				}
			}
			.contentBox{
				width:100%;
				margin-top:30px;
				text-align:left;
				.title{
					font-size:32px;
					color:#ad8f5a;
					letter-spacing:0;
					line-height:52px;
				}
				.eng-title{
					margin-top:20px;
					font-size:28px;
					letter-spacing:0;
					line-height:28px;
				}
				.abstract{
					margin-top:20px;
					font-size:28px;
					color:#000000;
					letter-spacing:0.07px;
					line-height:50px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs/exchangeJifen.vue